import { render, staticRenderFns } from "./selectTipoJuego.vue?vue&type=template&id=6f7ae68e&scoped=true"
import script from "./selectTipoJuego.vue?vue&type=script&lang=js"
export * from "./selectTipoJuego.vue?vue&type=script&lang=js"
import style0 from "./selectTipoJuego.vue?vue&type=style&index=0&id=6f7ae68e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7ae68e",
  null
  
)

export default component.exports